import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import FeedDetail from "../Home/FeedDetail";
import Footer from "../Home/Footer";

import { Avatar, Nodata } from "../../assets";
import { motion } from "framer-motion";
import { fadeInOut, imageWhileHover } from "../../utils/animations";
import { FaDiscord } from "../../assets/icons";
import { getAllFavourites } from "../../api";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";
import { useParams } from "react-router-dom";

const UserProfile = () => {
  const { uid } = useParams();

  const [isDiscord, setIsDiscord] = useState(false);
  const [{ user, favourites, mainLoader }, dispatch] = useStateValue();
  const randomImage =
    "https://source.unsplash.com/1600x900/?nature,photography,technology";

  useEffect(() => {
    // if (effectRun.current === true) {
    dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });

    if (!favourites || favourites?.length === 0) {
      getAllFavourites(uid).then((data) => {
        dispatch({ type: actionType.SET_FAVOURITES, favourites: data.data });
      });
    }

    setTimeout(() => {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
    }, 3000);
    // }
    return () => {
      // effectRun.current = true;
    };
  }, []);

  return (
    <div className="w-screen  flex flex-col items-center justify-center">
      <Header />
      <div className="w-full rounded-md relative flex flex-col items-center justify-center">
        <div className=" w-full h-420 rounded-md flex items-center justify-center overflow-hidden">
          <motion.img
            {...imageWhileHover}
            src={randomImage}
            className="object-cover w-full h-full"
          />
        </div>
        <img
          src={
            user?.picture || user?.photoURL
              ? user?.picture
                ? user?.picture
                : user?.photoURL
              : Avatar
          }
          className="rounded-full border-2 border-primary -mt-12 z-10"
          alt=""
        />
        <p className="text-3xl text-textColor capitalize font-semibold">
          {user?.name}
        </p>
      </div>

      <div className=" w-full px-6 md:px-24 flex flex-wrap items-center justify-between gap-6 gap-y-10 mt-8">
        {favourites && favourites?.length > 0 ? (
          favourites.map((concept, i) => (
            <FeedDetail key={i} index={i} data={concept} />
          ))
        ) : (
          <div className="w-full flex items-center justify-center gap-4 flex-col">
            <p className="text-4xl text-textColor font-semibold">
              No Favourites
            </p>
            <img src={Nodata} className="w-full md:w-508" alt="" />
          </div>
        )}
      </div>

      <a
        href="https://discord.gg/TsydV9XUJe"
        className=" fixed z-50 bottom-32 right-8 px-4 py-2  rounded-md flex  items-start
         gap-3 bg-blue-400 shadow-lg"
        target="_blank"
        onMouseEnter={() => setIsDiscord(true)}
        onMouseLeave={() => setIsDiscord(false)}
      >
        <FaDiscord className=" -rotate-0 text-4xl text-primary" />
        {isDiscord && (
          <motion.p
            {...fadeInOut}
            className="text-base text-textColor w-44 absolute bottom-16 -left-24 backdrop-blur-lg px-3 py-2 bg-card font-semibold rounded-md shadow-md"
          >
            {" "}
            Join our community
          </motion.p>
        )}
      </a>
      <Footer />
    </div>
  );
};

export default UserProfile;
